import { MsalAuthProvider, LoginType } from "react-aad-msal";
import { Logger, LogLevel } from "msal";
import {
  getRedirectUri,
  getLogoutRedirectUri,
  getAuthorityLoginPage,
  getAuthorityForgotPasswordPage,
  getClientId,
  getAuthScopes
} from "utils/config-environment";

const loggerCallback = (logLevel, message, containsPii) => {
  console.log(message);
};

// Export functions instead of values to ensure they're called after config is loaded
export const authorityLoginPage = () => getAuthorityLoginPage()
export const authorityForgotPasswordPage = () => getAuthorityForgotPasswordPage()

const config = (authority) => ({
  auth: {
    authority: authority ?? getAuthorityLoginPage(),
    clientId: getClientId(),
    redirectUri: getRedirectUri(),
    postLogoutRedirectUri: getLogoutRedirectUri(),
    validateAuthority: false,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
    secureCookies: true,
  },
  system: {
    logger: new Logger(loggerCallback, {
      level: LogLevel.Warning,
      piiLoggingEnabled: false,
    }),
  },
});

const options = {
  loginType: LoginType.Redirect,
};

export const authProvider = (authority) => {
  const authenticationParameters = {
    scopes: getAuthScopes()
  };
  
  return new MsalAuthProvider(
    config(authority),
    authenticationParameters,
    options
  );
};
